
import AdvSelect from '@/components/adv-select/AdvSelect.vue'
import { createAdTask } from '@/api/local-material'

export default {
    components: {
        AdvSelect
    },
    props: {
        showCreateAdTaskForm: {
            type: Boolean,
            required: true
        },
        model: {
            type: Object,
            default: () => null
        }
    },
    data () {
        return {
            labelCol: { span: 4 },
            wrapperCol: { span: 18 },
            loading: false,
            rules: {
                advertiser_id: [ { required: true, message: '请输入广告主ID', trigger: 'change' }],
                name: [ { required: true, message: '请输入任务名称', trigger: 'change' }],
            },
            title: '创建计划',
        }
    },
    created () {
        if (this.model.up_type === 2 || this.model.up_type === 3) {
            this.title = '推送视频到媒体'
        }
    },
    computed: {},
    mounted () {
    },
    methods: {
        submit() {
            console.log({local_material_id:this.model.id, advertiser_id: this.model.advertiser_id})
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
                this.storeOrUpdate()
            });
        },
        storeOrUpdate() {
            this.loading = true
            
            createAdTask({local_material_id:this.model.id,local_material_ids:this.model.local_material_ids,advertiser_id: this.model.advertiser_id, up_type:this.model.up_type ?? 1, material_id: this.model.material_id ?? null, material_advertiser_id: this.model.material_advertiser_id ?? null, media: this.model.media, name: this.model.name}).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    let message = ''
                    if (this.model.up_type === 2 || this.model.up_type === 3) {
                        message = '推送成功！'
                    } else {
                        message = '提交任务成功，请等待！'
                    }
                    this.$message.success(message)
                    this.$emit('success')
                    this.close()
                } else {
                    this.$message.error(res.message);
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        close() {
            this.$refs.form.resetFields()
            this.model.advertiser_id = null
            this.$emit('update:showCreateAdTaskForm', false)
            this.$emit('success')
        },
    }
}
